import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { Events } from '../../helpers/events';

// other libraries
import { TranslateService } from "@ngx-translate/core";

// rxjs
import { Subject } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";

// base
import { BasePage } from "../base";

// services
import { UserService } from "../../services/user.service";

// models
import { User } from "../../models/user";
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
    selector: 'app-event-key',
    templateUrl: './event-key.page.html',
    styleUrls: ['./event-key.page.scss'],
})
export class EventKeyPage extends BasePage implements OnInit {

    /**
     * unsubscribe subject
     *
     * @type {Subject<void>}
     */
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    /**
     * Form
     *
     * @type ViewChild
     */
    @ViewChild('f') form;

    /**
     * initial loading state
     *
     * @type {boolean}
     */
    public loading: boolean = true;

    /**
     * initial loading state
     *
     * @type {boolean}
     */
    public submit: boolean = false;

    /**
     * user
     *
     * @type {User}
     */
    public user: User;

    /**
     * validate state
     *
     * @type {boolean}
     */
    public validate: boolean = false;

    /**
     * Validation errors
     *
     * @type {object}
     */
    public validationErrors: object = {};

    /**
     * validation errors state
     *
     * @type {boolean}
     */
    public hasValidationErrors: boolean = false;

    /**
     * event key
     *
     * @type {string}
     */
    public eventKey: string;

    constructor(
        private auth: AuthenticationService,
        private route: ActivatedRoute,
        public appEvents: Events,
        public alertCtrl: AlertController,
        public translate: TranslateService,
        public userService: UserService
    ) { super(); }

    ngOnInit() {

        // get event key from url
        if (this.route.snapshot.params['event-key']) {
            this.eventKey = decodeURIComponent(this.route.snapshot.params['event-key']);
        }

        // subscribe to current user
        this.userService.getCurrentUser().pipe(
            takeUntil(this.ngUnsubscribe),
            debounceTime(0)
        ).subscribe((user) => {
            if (user.id) {
                this.user = user;
            } else {
                this.user = null;
            }
        });
        this.hideLoading();
    }

    logout() {
        this.appEvents.publish('logout', 'logout');
    }

    /**
     * use event key
     */
    public useEventKey() {
        this.loading = true;

        if (!this.submit) {
            this.validate = true;
            this.submit = true;
            this.userService.useEventKey(this.eventKey).subscribe(
                (success) => {

                    // update token in case that it is refreshed
                    if (success.token) {
                        this.auth.updateToken(success.token, true);
                    } else {

                        // reload user after updating participant
                        this.validate = false;
                        this.form.reset();
                        this.submit = false;
                        this.eventKey = null;
                        this.overlayService.showLoading();
                        this.appEvents.publish('user:current:participant', {
                            redirectLink: this.plt.defaultLink + '/home/info/matching'
                        });
                    }
                },
                (error) => {
                    this.submit = false;
                    const data = error.error;

                    if (data.fields) {
                        for (const field in data.fields) {
                            if (data.fields.hasOwnProperty(field)) {
                                this.hasValidationErrors = true;
                                this.validationErrors[field] = data.fields[field].join(' ');
                            }
                        }
                    }

                    this.overlayService.showError(data.message);
                });
        }
    }
}
